import React from "react"
import { Form } from "react-final-form"
import isEmail from "validator/lib/isEmail"
import { SimpleForm } from "Styles"
import { AddonInput } from "Components/FormElements"
import { FormHiddenFields, LoadingSpinner, Utils, FormPostSubscribe } from "Components"
import Config from "Data"

function ValidateEmail(email) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
  if (email.match(validRegex)) {
    return true
  } else {
    return false
  }
}

const emailblockReg =
  /^([\w]+@(?!gmail.com)(?!yahoo.com)(?!ymail.com)(?!hotmail.com)(?!msn.com)(?!aol.com)(?!live.com)(?!icloud.com)(?!me.com)([\w-]+\.)+[\w-]{2,4})?$/
const windowGlobal = typeof window !== "undefined" && window

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentModal: null,
      email: null,
      id: null,
      data: [],
      loading: false,
    }
  }

  componentDidMount() {
    this.setState({
      currentModal: null,
      email: null,
      id: null,
    })
  }

  toggleModal = (key, param) => (e) => {
    e.preventDefault()
    if (this.state.currentModal) {
      this.handleModalCloseRequest()
      return
    }

    this.setState({
      ...this.state,
      currentModal: key,
    })
  }

  handleModalCloseRequest = () => {
    this.setState({
      ...this.state,
      currentModal: null,
    })
  }

  handleOnAfterOpenModal = () => {}

  render() {
    const { props } = this
    const { loading } = this.state
    const { title, subtitle, banner, isOpen, closeModal, onAfterOpen, onRequestClose, onChangeInput, postSubscribe } =
      props
    const { currentModal } = this.state

    let formData = {
      formName: "FormSubscribe",
      origin: windowGlobal ? windowGlobal.location.href : "",
      retURL: "",
      country: windowGlobal.country,
      brand: Config.brand,
      email: "",
      id: Date.now() + Math.random().toString().slice(2),
      mailingList: "subscribe_cxosync",
    }

    const toggleLoading = (e) => {
      this.setState({ ...this.state, loading: false })
    }

    function postData(url = ``, data = {}) {
      return fetch(url, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        redirect: "follow",
        referrer: "no-referrer",
        body: JSON.stringify(data),
      })
        .then((response) => {
          response
            .json()
            .then((data) => {
              if (data.retURL) {
                windowGlobal.location = data.retURL
              } else {
                toggleLoading()
              }
            })
            .catch(function (e) {
              console.error("handled the error")
              console.error(e)
            })
        })
        .catch((error) => console.error("Error:", error))
    }

    const onSubmit = async (values) => {
      console.log(JSON.stringify(values, 0, 2))
      // if (postSubscribe) {
      //   this.setState({ currentModal: "modal_post_subscribe", email: values.email })
      //   console.log(this.state)
      // }
      this.setState({ currentModal: "modal_post_subscribe", email: values.email, id: values.id })
      // console.log(this.state)
      // this.setState({ loading: true })
      postData(Utils.endpoints.referee, values).catch((error) => console.error(error))
    }

    const handleChange = (e) => {
      formData[e.target.name] = e.target.value
      this.setState(formData)
    }

    return (
      <>
        {loading && <LoadingSpinner />}
        <Form
          initialValues={formData}
          onSubmit={onSubmit}
          validate={(values) => {
            const errors = {}
            if (!values.email) {
              errors.email = "Required"
            } else if (!isEmail(values.email)) {
              errors.email = "Invalid email"
            } else if (!ValidateEmail(values.email)) {
              errors.email = "Not a Company email!"
            }
            return errors
          }}
          render={({ form, handleSubmit, reset, submitting, pristine, values }) => (
            <>
              <SimpleForm className="form">
                <FormHiddenFields hiddenData={formData} />
                <AddonInput
                  name="email"
                  placeholder="Email (Corporate Only)"
                  label="Email (Corporate Only)"
                  className="AddonInput"
                  type="email"
                  onBlur={handleChange}
                  required={true}>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={submitting || pristine}
                    onClick={handleSubmit}
                    data-gtm={`Form Subscribe | Submit`}>
                    Subscribe
                  </button>
                </AddonInput>
              </SimpleForm>

              <FormPostSubscribe
                postSubscribe={postSubscribe}
                isOpen={currentModal === "modal_post_subscribe"}
                onAfterOpen={this.handleOnAfterOpenModal}
                onRequestClose={this.handleModalCloseRequest}
                email={this.state.email}
                id={this.state.id}
                closeModal={this.toggleModal("modal_post_subscribe", {
                  shareEvent: null,
                  showEvents: false,
                })}
              />

              {/* <FormDebug data={values}></FormDebug> */}
            </>
          )}
        />
      </>
    )
  }
}
